import { useMutation } from "react-query";
import { remove } from "./functions";
export default function useRemove() {
    return useMutation("remove", function (_a) {
        var user = _a.user, token = _a.token;
        return remove(user, token);
    });
}
